<template>
  <transition name="user-notifications-dialog">
    <div class="user-notifications-dialog" @keyup.escape="$emit('closed')">
      <header class="user-notifications-dialog-header">
        <h2>{{ $t('commonText.inbox') }}</h2>

        <button
          type="button"
          @click="$emit('closed')"
          class="close-button"
          id="close-notifications-dialog"
          tabindex="0"
        >
          <font-awesome-icon :icon="['fal', 'times']" size="2x"/>
        </button>
      </header>

      <app-tabs dynamic-height :active-tab="`notification-dialog-${type}`">
        <user-notifications-dialog-tab-updates />
        <user-notifications-dialog-tab-tips :item-id="itemId" :type="type" v-if="isFromBrasil"/>
      </app-tabs>
    </div>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex'
  import UserNotificationsDialogTabUpdates from './UserNotificationsDialogTabUpdates'
  import UserNotificationsDialogTabTips from './UserNotificationsDialogTabTips'

  export default {
    name: 'UserNotificationsDialog',
    components: {
      UserNotificationsDialogTabUpdates,
      UserNotificationsDialogTabTips
    },
    computed: {
      ...mapGetters('auth', [
        'isFromBrasil'
      ])
    },
    props: {
      type: String,
      itemId: [String, Number]
    },
    mounted () {
      this.$nextTick(() => {
        document.getElementById('close-notifications-dialog')?.focus()
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications-dialog {
    padding: 50px 0;
    position: fixed;
    top: var(--structure-header-height, 70px);
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    background: #fff;
    opacity: .95;
    transition: .3s $transition-ease-out;
    color: $color-tundora;

    > * {
      transition: opacity .35s .05s $transition-default,
                  transform .3s $transition-default;
      will-change: opacity, transform;
    }
  }

  .user-notifications-dialog-leave-active,
  .user-notifications-dialog-enter {
    opacity: 0;

    > * {
      opacity: 0;
      transform: translate3d(0, -10%, 0);
    }
  }

  .user-notifications-dialog-header {
    width: 990px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 25px;
      font-weight: 400;
      line-height: 34px;
    }

    button {
      @include clear-button;
      color: $color-darker-grey;
      font-weight: 700;

      &:hover {
        color: #000;
        transform: scale(1.05);
      }
    }
  }

  .app-tabs {
    width: 990px;
    margin: auto;
  }

  .close-button {
    cursor: pointer;
    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }
  }
</style>
